export function isRoot(permission) {
  return Number(permission?.root || 0) === 1;
}

export function hasPermission(permission, moduleKey, actionKey = "view") {
  if (isRoot(permission)) return true;
  if (!moduleKey) return true;
  const auth = permission?.auth || {};
  const actions = auth[moduleKey] || [];
  return actions.includes(actionKey);
}

export function canAccessRoute(permission, route) {
  const meta = route?.meta || {};
  if (isRoot(permission)) return true;
  if (meta.rootOnly) return false;
  return hasPermission(
    permission,
    meta.permissionKey,
    meta.permissionAction || "view"
  );
}

export function filterRoutesByPermission(routes, permission) {
  return (routes || [])
    .map((route) => {
      const next = { ...route };
      if (route.children) {
        next.children = filterRoutesByPermission(route.children, permission);
      }
      return next;
    })
    .filter((route) => {
      if (route.meta?.hidden) return false;
      if (route.children) {
        return route.children.length > 0 || canAccessRoute(permission, route);
      }
      return canAccessRoute(permission, route);
    });
}

export function firstVisiblePath(route) {
  const child = (route.children || []).find((item) => !item.meta?.hidden);
  return child ? child.path : route.path;
}
